import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_form = _resolveComponent("el-form")
  const _component_cus_dialog = _resolveComponent("cus-dialog")

  return (_openBlock(), _createBlock(_component_cus_dialog, {
    title: _ctx.title,
    operation: _ctx.operation,
    modelValue: _ctx.dialogFormVisible,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogFormVisible = $event)),
    onCancel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clearForm())),
    onOperate: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleCreateOrUpdate())),
    processing: _ctx.loading,
    width: "700px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: _ctx.form,
        rules: _ctx.rules,
        ref: "formRef",
        size: "small",
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "会社コード",
            prop: "kaishaCd"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.kaishaCd,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.kaishaCd = $event)),
                maxlength: "6",
                disabled: _ctx.operation === _ctx.DialogGenre.Edit
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "会社名",
            prop: "kaishaNm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.kaishaNm,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.kaishaNm = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "運用区分",
            prop: "unyoCd"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.form.unyoCd,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.unyoCd = $event)),
                "popper-class": "kaisha-unyo"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.unyoList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.unyo_kubun,
                      value: item.unyo_kubun_cd
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "業種分類名",
            prop: "gyoushuCd"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.form.gyoushuCd,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.gyoushuCd = $event)),
                filterable: "",
                "popper-class": "kaisha-gyoushu"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gyoushuList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.gyoushu_bunrui_nm,
                      value: item.gyoushu_bunrui_cd
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.operation === _ctx.DialogGenre.Edit)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "無効フラグ",
                prop: "mukoFlg"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.form.mukoFlg,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.mukoFlg = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.operation === _ctx.DialogGenre.Edit && _ctx.form.mukoDate)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: "無効日時",
                prop: "mukoDate"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.mukoDate,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.mukoDate = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "operation", "modelValue", "processing"]))
}